/** @prettier */

import CloudWatch from 'aws-sdk/clients/cloudwatch';

// TODO: debug logging...
// const logger = require('@welibraryos/logger').server({ id: 'metrics.js' });

const errHandler = err => {
    if (err) {
        console.log('[ERROR] Failed to publish metric', err);
    }
};

let ns = 'WeLibrary'; // should be reset on init
let cw = null;

export const metricInit = ({ namespace, accessKeyId, secretAccessKey, region }) => {
    const tempCw =
        accessKeyId && secretAccessKey && region
            ? new CloudWatch({ accessKeyId, secretAccessKey, region })
            : null;

    if (!tempCw) {
        console.log('[ERROR] No access or secret key provided for metric publishing');
    }

    cw = tempCw;
    ns = namespace;

    return cw;
};

export const metricPublisher = {
    publishCount: (metricName, count, dimensions = []) => {
        if (process.env.NODE_ENV === 'development') {
            console.log(metricName, count, dimensions);
        }
        if (cw) {
            cw.putMetricData(
                {
                    MetricData: [
                        {
                            MetricName: metricName,
                            Value: count,
                            Dimensions: dimensions,
                        },
                    ],
                    Namespace: ns,
                },
                errHandler
            );
        }
    },
    publishCustom: payload => {
        if (process.env.NODE_ENV === 'development') {
            console.log(payload);
        }
        if (cw) {
            cw.putMetricData(payload, errHandler);
        }
    },
};
